import React, { forwardRef, useEffect, useState } from 'react';
import { MAGNITT_ACCESS_ROLES } from '/src/lib/constants/userRoles';
import investorApi from '/src/apis/investorApi';
import FundsRaised from './FundsRaised/FundsRaised';
import FundPortfolio from './FundPortfolio/FundPortfolio';
import NewBadge from '/src/components/Reusable/NewBadge';
import Skeleton from 'react-loading-skeleton';

const ManagedFundsSection = forwardRef((props, ref) => {
    const { fundingTableProps, onFundClick = null } = props;
    const { user, entityId, entityType, entityData } = fundingTableProps;
    const [fundsCount, setFundsCount] = useState(0);
    const [isLoading, setIsLoading] = useState(true);
    const investorName = entityData?.name || 'Investor';

    useEffect(() => {
        if (user.is_loggedin && user.roles.includes(MAGNITT_ACCESS_ROLES.directory_access)) {
            investorApi.getFundsForInvestor(entityId, entityType)
                .then((res) => {
                    setFundsCount(res?.navigation?.total ?? 0);
                })
                .catch(() => {
                    setFundsCount(0);
                })
                .finally(() => {
                    setIsLoading(false);
                });
        } else {
            setIsLoading(false);
        }
    }, []);

    // show skeleton while fetching; hide entirely if the investor has no managed funds
    if (isLoading) {
        return (
            <div className="profile-section-box fundingrounds mf-section-wrapper">
                <h2 className="profile-section-heading">Managed Funds</h2>
                <div className="mf-skeleton__cards">
                    {[1, 2, 3].map(n => (
                        <div key={n} className="mf-skeleton__card">
                            <Skeleton width={90} height={11} style={{ marginBottom: 8 }} />
                            <Skeleton width={70} height={22} style={{ marginBottom: 6 }} />
                            <Skeleton width={110} height={11} />
                        </div>
                    ))}
                </div>
                <Skeleton height={42} borderRadius={0} style={{ marginBottom: 2 }} />
                {[1, 2, 3, 4, 5].map(n => (
                    <Skeleton key={n} height={50} borderRadius={0} style={{ marginBottom: 2 }} />
                ))}
            </div>
        );
    }

    if (fundsCount === 0) return null;

    return (
        <div ref={ref} className="portfolio-list-section profile-section-box mf-section-wrapper" id="section-managedfunds">
            <h2 className="profile-section-heading">Managed Funds <NewBadge /></h2>

            <FundsRaised
                entityId={entityId}
                entityType={entityType}
                investorName={investorName}
                onFundClick={onFundClick}
            />

            <hr className="mt-4 mb-0" />

            <FundPortfolio
                entityId={entityId}
                entityType={entityType}
                investorName={investorName}
                portfolioCompanyCount={entityData?.number_of_entities}
                user={user}
            />
        </div>
    );
});

export default ManagedFundsSection;
